import * as React from 'react';

var _path, _path2, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgId = function SvgId(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_19_318)",
        fillOpacity: 0.16,
        fillRule: "evenodd",
        d: "M41.2 16a2 2 0 0 0-2 2v11.6H24a4 4 0 0 0-4 4v24.8a4 4 0 0 0 4 4h38.4a4 4 0 0 0 4-4V33.6a4 4 0 0 0-4-4H47.2V18a2 2 0 0 0-2-2z",
        clipRule: "evenodd"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_19_318)",
        d: "M55.533 39.79q.434 0 .717-.3t.283-.757a.96.96 0 0 0-1-.994H46.61a1.05 1.05 0 0 0-.734.291.96.96 0 0 0-.317.739q0 .447.317.733.316.288.734.288zm0 6.148q.434 0 .717-.299.283-.3.283-.757a.96.96 0 0 0-1-.995H46.61a1.05 1.05 0 0 0-.734.292.96.96 0 0 0-.317.739q0 .446.317.733.316.288.734.287zM44.831 25.333h15.477q1.537 0 2.614 1.078Q64 27.488 64 29.026v27.282q0 1.537-1.078 2.614Q61.845 60 60.309 60H19.692q-1.537 0-2.614-1.078Q16 57.845 16 56.309V29.026q0-1.538 1.078-2.615 1.077-1.078 2.614-1.078h15.493V14.051q0-.795.627-1.424Q36.44 12 37.236 12h5.544q.858 0 1.455.627.596.628.596 1.424zm-7.595 2.052h5.544V14.05h-5.544zm-5.419 16.502q1.23 0 2.1-.884.873-.885.873-2.114 0-1.23-.86-2.126-.86-.897-2.089-.896-1.229 0-2.124.882a2.9 2.9 0 0 0-.896 2.142q0 1.204.884 2.1.883.897 2.112.896m-7.222 6.364h14.292v-.266q0-.922-.465-1.69a2.62 2.62 0 0 0-1.258-1.095q-1.673-.63-2.923-.864a13.3 13.3 0 0 0-2.436-.233q-1.215 0-2.571.274t-2.85.823a2.6 2.6 0 0 0-1.325 1.096 3.2 3.2 0 0 0-.464 1.689zm10.59-22.866H19.692q-.718 0-1.18.461-.46.462-.46 1.18v27.282q0 .717.46 1.18.462.46 1.18.46h40.616q.717 0 1.18-.46.46-.463.46-1.18V29.026q0-.718-.46-1.18-.463-.461-1.18-.461H44.83q0 1.302-.72 1.676-.721.375-1.972.375H37.86q-1.235 0-1.956-.375-.72-.374-.72-1.676"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_19_318",
        x1: 20.485,
        x2: 65.754,
        y1: 39.2,
        y2: 39.2,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_19_318",
        x1: 16.501,
        x2: 63.332,
        y1: 36,
        y2: 36,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgId as ReactComponent };
//# sourceMappingURL=ID.svg.es.js.map
